import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import PeersMultiTable from './PeersMultiTable';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 400,
    minHeight: 250,
    marginTop: '1.5rem'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: 17,
    fontFamily: 'PT Serif',
    color: '#001E41',
    fontWeight: 'bold'
  },
  dropDown: {
    textAlign: 'right',
    marginTop: 10,
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  details: {
    fontFamily: 'PT sans',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#002380',
    cursor: 'pointer'
  },
  data: {
    marginTop: '1rem',
    textAlign: 'center'
  },
  formControl: {
    minWidth: 105
  },
  selectContainer: {
    textAlign: 'right'
  },
  select: {
    borderRadius: '7px',
    '& .MuiOutlinedInput-input': {
      padding: '9.5px 25px 9.5px 13px'
    }
  }
}));

const PeersMulti = () => {
  const classes = useStyles();
  const [calc, setCalc] = useState('');

  const handleChangeCalc = (e) => {
    const newCalc = e.target.value;
    setCalc(newCalc);
  };

  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <div className={classes.container}>
          <Typography className={classes.title} gutterBottom>
            Peers Multiples
          </Typography>
          <Typography className={classes.details} gutterBottom>
            See details
          </Typography>
        </div>
        <div className={classes.selectContainer}>
          <FormControl className={classes.formControl} variant="outlined">
            <Select
              className={classes.select}
              inputProps={{
                name: 'calc',
                id: 'calc'
              }}
              native
              onChange={handleChangeCalc}
              value={calc}>
              <option value="EV/EBITDA">EV/Revenues</option>
              <option value="REVENUE/GROWTH">Revenue/Growth</option>
              <option value="NET DEBT/EBITDA">Net Debt/Ebitda</option>
            </Select>
          </FormControl>
        </div>
        <PeersMultiTable />
        <hr
          style={{
            width: '100%',
            margin: '1rem auto',
            color: '#D8D8D8',
            opacity: '0.3'
          }}
        />
      </CardContent>
    </Card>
  );
};

export default PeersMulti;
